import path from 'utils/path'
import SettingsPage from 'pages/Settings/SettingsPage'

export default class {
    path = path('system.settings')
    component = SettingsPage
}